import { useState } from "react";
import { toast } from "sonner";
import { useApi } from "@/lib/useApi";
import { api, errMsg, fmtDate } from "@/lib/api";
import { Loading } from "@/components/RequireAuth";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

const today = () => new Date().toISOString().slice(0, 10);

const RateRow = ({ r, reload }) => {
  const [v, setV] = useState(r.rate?.per_1000_xof ?? "");
  const [d, setD] = useState(r.rate?.rate_date ?? today());
  const save = async () => {
    try { await api.put(`/admin/exchange-rates/${r.currency}`, { per_1000_xof: Number(v), rate_date: d }); toast.success(`Taux ${r.currency} enregistré`); reload(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div data-testid={`rate-row-${r.currency}`} className="flex flex-wrap items-center gap-3 p-3 text-sm">
      <div className="min-w-0 flex-1"><p className="font-semibold">{r.currency} · {r.label}</p><p className="truncate text-xs text-gray-500">{r.countries.join(", ")}</p>
        {r.rate && <p className="text-xs text-gray-500">Taux du {fmtDate(r.rate.rate_date)} · saisi par {r.rate.updated_by}</p>}</div>
      <label className="flex items-center gap-2 text-xs text-gray-600">1 000 FCFA =<Input data-testid={`rate-value-${r.currency}`} type="number" min="0" step="any" value={v} onChange={(e) => setV(e.target.value)} className="w-32" />{r.label}</label>
      <Input data-testid={`rate-date-${r.currency}`} type="date" max={today()} value={d} onChange={(e) => setD(e.target.value)} className="w-40" />
      <Button size="sm" disabled={!(Number(v) > 0) || !d} onClick={save} data-testid={`rate-save-${r.currency}`}>Enregistrer</Button>
    </div>
  );
};

export default function AdminRates() {
  const { data, reload } = useApi("/admin/exchange-rates");
  return (
    <div data-testid="admin-rates" className="space-y-5">
      <h1 className="font-display text-3xl font-black tracking-tight">Taux de change</h1>
      <p className="text-sm text-gray-500">Saisissez manuellement la valeur de 1 000 FCFA dans chaque monnaie, avec la date du taux. Les vendeurs voient un équivalent indicatif (arrondi supérieur) avec la mention « Seul le montant en FCFA est payable ». Sans taux saisi, aucun équivalent n'est affiché.</p>
      {!data ? <Loading /> : <div className="divide-y rounded-xl border bg-white">{data.map((r) => <RateRow key={r.currency} r={r} reload={reload} />)}</div>}
    </div>
  );
}
